import {CalendarDate, type DateValue, fromDate, getLocalTimeZone} from '@internationalized/date'

import {BookingType, TravelClass} from './types'

export function isBookingType(bookingType: unknown): bookingType is BookingType {
  if (typeof bookingType !== 'string') return false
  return Object.values(BookingType).includes(bookingType)
}

export function isTravelClass(travelClass: unknown): travelClass is TravelClass {
  if (typeof travelClass !== 'string') return false
  return Object.values(TravelClass).includes(travelClass)
}

export const getCalendarDateForToday = () =>
  new CalendarDate(
    fromDate(new Date(), getLocalTimeZone()).year,
    fromDate(new Date(), getLocalTimeZone()).month,
    fromDate(new Date(), getLocalTimeZone()).day,
  )

export function dateValueToDateValueString(dateValue: DateValue) {
  return `${dateValue.year}-${dateValue.month.toString().padStart(2, '0')}-${dateValue.day.toString().padStart(2, '0')}`
}

export function dateValueToDate(dateValue: DateValue) {
  return new Date(dateValue.year, dateValue.month - 1, dateValue.day)
}

export function isDateValueString(dateValue: unknown): dateValue is string {
  if (typeof dateValue !== 'string') return false
  const [year, month, day] = dateValue.split('-')
  return !Number.isNaN(Number(year)) && !Number.isNaN(Number(month)) && !Number.isNaN(Number(day))
}

export function dateValueStringToDateValue(dateValueString: string): DateValue {
  if (!isDateValueString(dateValueString)) throw new Error('Invalid date value string')
  const [year, month, day] = dateValueString.split('-').map(Number)
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- we already checked the format
  return new CalendarDate(year!, month!, day!)
}

export function validatePassengers(
  numOfAdult: number,
  numOfChildren: number,
  numOfInfantsInSeat: number,
  numOfInfantsOnLap: number,
) {
  if (numOfAdult < 1) return 'You must have at least 1 adult'
  if (numOfInfantsOnLap > numOfAdult) return 'You must have at least one adult per infant on lap'
  if (numOfInfantsInSeat + numOfInfantsOnLap > numOfAdult * 2)
    return 'You must have at least one adult per two infants'
  if (numOfAdult + numOfChildren + numOfInfantsInSeat + numOfInfantsOnLap > 9)
    return 'Sorry, we do not support more than 9 passengers'

  return true
}

// TODO: check if timezone is taken into account
export function calculateAge(dateOfBirth: Date) {
  const today = new Date()
  const birthDate = new Date(dateOfBirth)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  const dayDiff = today.getDate() - birthDate.getDate()
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--
  }
  return age
}
